import React, { ChangeEvent } from 'react';
import './UiInput.scss';

type PropsType = {
  label: string;
  value: string;
  className?: string;
  dataTestId?: string;
  placeholder?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const UiInput = ({ label, value, className, dataTestId, placeholder, onChange }: PropsType) => {

  return (
    <div className={`ui-input${className ? ` ${className}` : ''}`} data-testid={dataTestId}>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className="ui-input__input"
      />
      <label
        className={`ui-input__label ${
          value ? 'ui-input__label--active' : ''
        }`}
      >
        {label}
      </label>
    </div>
  );
};

export default UiInput;
